import {
  IonButton,
  IonContent,
  IonPopover,
  IonIcon
} from "@ionic/react";
import React, { useState } from "react";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";
import MonthYearRequestBtn from "./MonthYearRequestBtn";
import { createOutline } from "ionicons/icons";

interface Props {
  id: string;
  name: string;
}

async function downloadReport(
  token: string,
  id: string,
  month: number,
  year: number
) {
  return fetch(`${API_URL}/reports/cost_avoidance`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      building: id,
      month: month,
      year: year,
    }),
  }).then(async (res: any) => {
    if (res.ok) {
      return res.blob();
    } else {
      const data = await res.json();
      return {
        error: data.error,
      };
    }
  });
}

const CostAvoidanceReportButton: React.FC<Props> = ({ id, name }) => {
  const [loading, setLoading] = useState(false);
  

  const handleDownload = async (month:number,year:number) => {
    setLoading(true);
    const tkn: any = localStorage.getItem("token");
    const token = `Token ${tkn.slice(1, -1)}`;
    const res = await downloadReport(token, id, month,year);
    if ("error" in res) {
      NotificationPopUp("error", res["error"], "Error Generating Report");
    } else {
      const url = window.URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}_Cost_Avoidance_Report.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode!.removeChild(link);
    }
    setLoading(false);
  };

  return (
    <div>
      <IonButton
        id="download-cost-avoidance-report"
        fill="solid"
        size="small"
        color="medium"
        // onClick={()=>handleDownload()}
      >
        Cost Avoidance Report
      </IonButton>
      <IonPopover
        trigger="download-cost-avoidance-report"
        size="auto"
        side="bottom"
        alignment="center">
          <IonContent color="medium" style={{ padding: "1rem" }}>
            <div style={{textAlign: "center", padding: "0.2rem 1rem 1rem"}}>
              <div style={{width:'100%',textAlign:'end'}}>
                <IonButton
                  title="Edit Cost Avoidance Report"
                  fill="outline"
                  color="dark"
                  size="small"
                  href={`cost_avoidance_report/${id}/edit`}
                  disabled={loading}
                  >
                    <IonIcon color="dark" src={createOutline}/>
                </IonButton>
              </div>
              <MonthYearRequestBtn handleRequest={handleDownload} loading={loading}/>
            </div>
            
          </IonContent>
        </IonPopover>

    </div>
  );
};

export default CostAvoidanceReportButton;
